import ModalBase from './ModalBase'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { reExportedColors, Text } from '../index'
import SaveCancelButtonFooter from '../Buttons/SaveCancelButtonFooter'
import { useImageUploaderModal } from '../../../services/customHooks/useImageUploaderModal'
import styled from '@emotion/styled'
import React, { useState, useEffect } from 'react'
import UploadLocationImageModal from '../../3modules/UploadLocationImageModal/UploadLocationImageModal'
import { useNavigate, useParams } from 'react-router-dom'
import ApiService from '../../../common/ApiCalls'
import ImageUploadLink from '../../2compounds/ImageUploadLink/ImageUploadLink'
import ToggleButton from '../Buttons/ToggleButton'
import googleLogo from '../../../assets/google_logo.png'
import userIcon from '../../../assets/usericon.png'
import MoreVertButton from '../Buttons/IconButtons/MoreVertButton/MoreVertButton'

export default function ImageUploaderModal ({ open, setOpen, imageUrlArray, setImageUrlArray, pushImageUrlArray }) {
  const classes = useStyles()
  const { cancelHandler } = useImageUploaderModal({ open, setOpen, imageUrlArray, setImageUrlArray, pushImageUrlArray })
  const [modal, setModal] = useState('')
  const [editMode, setEditMode] = useState(false)
  const [picData, setPicData] = useState()
  const [order, setOrder] = useState()
  const [photo, setPhoto] = useState([])
  const [userSetting, setUserSetting] = useState()
  const [iscolor, setColor] = useState(reExportedColors.BLACK)
  const { tabName, id } = useParams()
  const navigate = useNavigate()

  const UserSelect = async () => {
    await ApiService().googlePullImage(userSetting, id, tabName)
    navigate(0)
  }

  const OpenOptions = (index) => {
    const target = document.getElementById('option' + index)
    const all = document.querySelectorAll('[id^="option"]')
    setOrder(index)
    const copyData = photo[index]
    setPicData(copyData)
    for (let i = 0; i < photo.length; i++) {
      all[i].style.display = 'none'
    }
    if (target.style.display === 'none') {
      target.style.display = 'flex'
      setModal('option' + index)
    }
    if (modal === target.id) {
      target.style.display = 'none'
      setModal('')
    }
  }

  const DeleteHandler = async (index) => {
    const selectedPhoto = imageUrlArray[index].fieldData
    await ApiService().deleteLocationImage(selectedPhoto, id, tabName)
    navigate(0)
  }

  const DefaultHandler = async (index) => {
    const selectedPhoto = imageUrlArray[index].fieldData
    photo.filter((el) => el !== selectedPhoto)
    await ApiService().defaultLocationImage(selectedPhoto, id, tabName)
    navigate(0)
  }

  useEffect(() => {
    const getTabViewData = async () => {
      try {
        const res = await ApiService().getTabView(id, tabName)
        const photoArray = []
        for (let i = 0; i < res.length; i++) {
          if (res[i].card_sys_name === 'Card 2') {
            photoArray.push(res[i].data)
          }
        }
        const arrange = photoArray.filter(pic => pic.length > 1)
        setPhoto(arrange)
      } catch (e) {
        console.log(e)
      }
    }
    getTabViewData()
  }, [id, tabName])

  useEffect(() => {
    const getUserState = async () => {
      try {
        const states = await ApiService().userStatesPullImage(id, tabName)
        setUserSetting(states)
      } catch (e) {
        console.log(e)
      }
    }
    getUserState()
  }, [id, tabName])

  return (
    <ModalBase open={open} setOpen={setOpen}>
      <div className={classes.root}>
        <div className={classes.headerTitle}>
          <div className={classes.titleContainer}><Text type='h2'>Edit Image(s)</Text></div>
        </div>
        <div className={classes.container}>
          <div className={classes.headerDiv}>
            <Text type='p'>When toggle icon is enabled automatically 10 images are randomly pulled from Google, rest of the images can be uploaded by the user. If you wish to replace Google Images with your own, please use the icon next to the image.</Text>
          </div>

          <OptionContainer>
            <ToggleButton isSwitch={userSetting} setSwitch={setUserSetting} isColor={iscolor} setColor={setColor} />
          </OptionContainer>

          <div className={classes.editorList}>
            {
              imageUrlArray.map((image, index) => (
                <div key={index} className={classes.imageContainer}>
                  <div className={classes.thumbnailDiv}>
                    <>
                      {(image.fieldData && image.fieldData !== ' '
                        ? <div><MoreVertButton className={classes.deleteButton} onClick={() => OpenOptions(index)} />
                          <img src={image.fieldData} className={classes.thumbnail} alt='Not found' />

                          <Option key={index} id={'option' + index}>
                            <OptionList onClick={() => setEditMode(true)}><Text type='h6'>Upload New Images</Text></OptionList>
                            {(!image.fieldData.includes('photo_reference') &&
                                (
                                  <>
                                    <OptionList onClick={() => DefaultHandler(index)}><Text type='h6'>Use as Default</Text></OptionList>
                                    <OptionList onClick={() => DeleteHandler(index)} style={{ borderBottom: '0px' }}><Text type='h6'>Delete Image</Text></OptionList>
                                  </>
                                ))}
                          </Option>

                          {(image.fieldData.includes('photo_reference')
                            ? <>
                              <LogoContainer>
                                <img src={googleLogo} alt='Google Maps' />
                              </LogoContainer>
                              </>
                            : <>
                              <LogoContainer>
                                <img src={userIcon} alt='User Uploaded' />
                              </LogoContainer>
                              </>)}
                          </div>
                        : <div><ImageUploadLink setEditMode={setEditMode} /></div>)}
                    </>

                  </div>
                </div>
              ))
}
            <UploadLocationImageModal onEditMode={editMode} setOnEditMode={setEditMode} id={id} tabName={tabName} Num={order} imageUrlArray={photo} pic={picData} />
          </div>
          <SaveCancelButtonFooter saveHandler={() => UserSelect()} cancelHandler={() => cancelHandler()} className={classes.buttonDiv} />
        </div>
      </div>
    </ModalBase>
  )
}

const useStyles = makeStyles({
  buttonDiv: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  editorList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(3, 1fr)',
    gridGap: '30px',
    height: '600px',
    alignItems: 'center',
    overflowY: 'auto'
  },
  root: {
    width: '100%',
    maxWidth: 800,
    '& .MuiTextField-root': {
      margin: '10px 0',
      width: '100%',

      '& .MuiInputBase-input': {
        padding: 0
      }
    }
  },
  container: {
    padding: '25px',
    width: '100%',
    maxWidth: 800
  },
  titleContainer: {
    display: 'flex',
    margin: 20
  },
  imageTile: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative'
  },
  uploadedImage: {
    width: '195px',
    height: '130px',
    objectFit: 'contain',
    borderRadius: '4px'
  },
  deleteButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    '& button': {
      background: reExportedColors.WHITE,
      padding: 2,
      '&:hover': {
        background: reExportedColors.WHITE,
        borderRadius: '50%'
      }
    }
  },
  inputDiv: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: '195px',
    '& button': {
      marginRight: 'auto'
    }
  },
  imgNotFoundMessage: {
    alignItems: 'center',
    display: 'flex',
    position: 'absolute',

    '& img': {
      width: '14px',
      margin: '-3px 5px 0 0'
    },

    '& p': {
      color: reExportedColors.RED,
      fontSize: '12px',
      fontWeight: 'bolder',
      margin: 0
    }
  },
  headerDiv: {
    marginBottom: 20,
    width: '100%'

  },
  headerTitle: {
    display: 'flex',
    background: reExportedColors.LIGHT_GREY,
    alignItems: 'center',
    width: '100%',
    height: '100%',
    justifyContent: 'center'
  },
  thumbnail: {
    width: 195,
    height: 135,
    objectFit: 'cover',
    borderRadius: 23
  },
  urlField: {
    width: '100%'
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%'
  },
  imageContainerDefault: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    border: '1px solid black'
  },
  thumbnailDiv: {
    width: 195,
    height: 135,
    marginBottom: 5,
    position: 'relative'
  }
})

const Option = styled.div({
  display: 'none',
  width: 100,
  background: reExportedColors.WHITE,
  flexDirection: 'column',
  justifyContent: 'center',
  position: 'absolute',
  zIndex: 10,
  top: 25,
  right: 0,
  boxShadow: '1px 2px 5px rgba(0, 0, 0, 0.25)',
  borderRadius: '3px 0px 3px 3px'
})

const OptionList = styled.div({
  display: 'flex',
  padding: '2px 5px',
  borderBottom: `0.1px solid ${reExportedColors.DARK_GREY}`,
  cursor: 'pointer'
})

const OptionContainer = styled.div({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',
  marginBottom: 14
})

const LogoContainer = styled.div({
  display: 'flex',
  width: '16%',
  height: '14%',
  position: 'absolute',
  top: 110,
  right: 150
})
